import { useSelector } from 'react-redux';
import { LocalizedMinorHighlight, LocalizedSmallParagraph } from '@mews-commander/ui';
import { FormSwitchField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Divider, Stack } from '@optimus-web/core';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { ConfigureScimFieldNames } from '../useConfigureScimForm';
import { CopyableInput } from './CopyableInput';
import { ScimProviderSelectionCardGroupField } from './ScimProviderSelectionCardGroupField';
import { useTenantUrl } from './useTenantUrl';
import { ScimSecretTokenField } from './ScimSecretTokenField';

export function ConfigureScimPanelContent() {
    const isPortfolio = useSelector(isCurrentEnterprisePortfolio);
    const tenantUrl = useTenantUrl();

    return (
        <Stack vertical spacing="500">
            {!isPortfolio && (
                <Banner variant="info" primaryText={<LocalizedText textKey={TextKey.ScimEnterpriseBannerNotice} />} />
            )}

            <Stack vertical spacing="300">
                <Divider />
                <FormSwitchField
                    label={<LocalizedText textKey={TextKey.EnableScimUserProvisioning} />}
                    name={ConfigureScimFieldNames.Enabled}
                />
                <Divider />
            </Stack>

            <Stack spacing="200" vertical>
                <LocalizedMinorHighlight textKey={TextKey.SelectIdentityProvider} />
                <ScimProviderSelectionCardGroupField />
            </Stack>

            <Stack vertical spacing="300" itemAlignment="start">
                <Stack vertical spacing="50">
                    <LocalizedMinorHighlight textKey={TextKey.ScimConfiguration} />
                    <LocalizedSmallParagraph textKey={TextKey.ScimConfigurationDescription} />
                </Stack>

                <CopyableInput
                    label={<LocalizedText textKey={TextKey.TenantUrl} />}
                    name="tenant-url"
                    value={tenantUrl}
                    readOnly
                />
                <ScimSecretTokenField />
            </Stack>
        </Stack>
    );
}
